export default __webpack_public_path__ + "static/media/winner_11.a34c2048.jpg";